import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from './login.service';
import { Login } from '../../../models/login';
import { AuthService } from '../../../shared/services/auth.service';
import { BuyerModel } from '../../../models/BuyerModel';
import { CommonService } from '../../../shared/services/common.service';
import { Subscription } from 'rxjs/Subscription';
import { SignalRService } from '../../../services/signalr.service';
import { SubscriptionService } from '../../../shared/services/subscription.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  model: Login = new Login();
  error: string;
  isLoading: boolean;
  returnUrl: string;
  private subscriptions: Subscription[] = [];
  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public loginService: LoginService,
    private signalrService: SignalRService,
    public authService: AuthService,
    public subscriptionService: SubscriptionService,
    public commonService: CommonService) {
    this.isLoading = false;
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  ngOnDestroy() {
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  onForgotPassword() {
    this.router.navigate(["/forgotpassword/"]);
  }

  login() {
    this.isLoading = true;
    this.subscriptions.push(this.loginService.login(this.model).subscribe(async res => {
      this.authService.setAuhToken(res.access_token);
      localStorage.setItem('refresh_token', res.refresh_token);
      let buyerDetails = await this.commonService.getCurrentBuyerDetails().toPromise();
      this.commonService.setAuthUser(buyerDetails);
      this.isLoading = false;
      if (res && buyerDetails) {
        await this.signalrService.resolve(buyerDetails["BuyerID"]);
        
        //this.subscriptionService.setBuyerInfo(buyerDetails["BuyerID"],buyerDetails["IsCobuyer"],buyerDetails["CoBuyerID"]);
        var data={
          BuyerID:buyerDetails["BuyerID"],
          IsCobuyer: buyerDetails["IsCobuyer"],
          CoBuyerID: buyerDetails["CoBuyerID"]
        }
        localStorage.setItem('BuyerInfo',JSON.stringify(data));
        this.router.navigateByUrl(this.returnUrl);

      } else {
        this.error = 'The username or password you entered is incorrect';
      }
    }, err => {
      this.isLoading = false;
      this.error = (err && err.error) ? err.error.Message : "The username or password you entered is incorrect";
    }));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/non-auth/login/login.component.ts